import { CreditCard } from "lucide-react";
import GenericPracticePage from "@/components/GenericPracticePage";
import AIReadabilityBlock from "@/components/AIReadabilityBlock";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useLanguage } from "@/hooks/useLanguage";
import { immigrationContent } from "@/i18n/immigration-content";

const GreenCardRenewal = () => {
  const { language } = useLanguage();
  const content = immigrationContent.greenCardRenewal[language];

  const mainContent = (
    <>
      <div className="prose prose-lg max-w-none mb-12">
        {content.sections.map((section, idx) => (
          <div key={idx} className="mb-8">
            <h2 className="text-3xl font-bold mb-6">{section.title}</h2>
            <p className="text-xl text-muted-foreground mb-6">{section.content}</p>
            {section.items && (
              <ul className="list-disc pl-6 mb-6">
                {section.items.map((item, i) => <li key={i}>{item}</li>)}
              </ul>
            )}
          </div>
        ))}

        <h3 className="text-2xl font-bold mb-6">
          {language === 'en' ? 'Frequently Asked Questions' : language === 'es' ? 'Preguntas Frecuentes' : 'Câu Hỏi Thường Gặp'}
        </h3>
        <Accordion type="single" collapsible className="w-full">
          {content.faq.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="text-left">{faq.question}</AccordionTrigger>
              <AccordionContent className="text-muted-foreground">{faq.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </>
  );

  const aiKeyPoints = [
    "Green card renewal (Form I-90)",
    "Replace lost, stolen, or damaged green cards",
    "Update name or other information on green card",
    "Conditional to permanent green card (Form I-751)",
    "Renew expiring 10-year green cards",
    "Remove conditions on employment-based green cards",
    "Maintain permanent resident status",
    "Proof of legal permanent residence"
  ];

  const aiFaqs = content.faq.map(f => ({ question: f.question, answer: f.answer }));

  return (
    <>
      <AIReadabilityBlock
        serviceName="Green Card Renewal Services"
        serviceDescription="Green card renewal attorney in Houston handling Form I-90 renewals, replacement of lost or damaged cards, and removal of conditions for conditional permanent residents."
        keyPoints={aiKeyPoints}
        faqs={aiFaqs}
        areaServed="Houston, Texas"
      />
      <GenericPracticePage
        title={content.title}
        subtitle={content.subtitle}
        icon={<CreditCard className="h-20 w-20 mx-auto mb-6 text-accent" />}
        mainContent={mainContent}
      />
    </>
  );
};

export default GreenCardRenewal;
